import { render, staticRenderFns } from "./SocialWidget.vue?vue&type=template&id=77177fe1&"
import script from "./SocialWidget.vue?vue&type=script&lang=js&"
export * from "./SocialWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/SocialWidget.vue
// module id = null
// module chunks = 